

























import { createComponent, ref, inject } from '@vue/composition-api'
import { BASE_MAP, BASE_MAP_NAME, MapFactoryController } from '@/lib/map'
import { MainMapControllerSymbol } from '@/symbols'

export default createComponent({
  name: 'SwitchMapModeButto',
  setup () {
    const mapModeBottomSheet = ref(false)
    const mapController = inject(MainMapControllerSymbol, ref<MapFactoryController>())

    const mapModes = [BASE_MAP.SATELITE, BASE_MAP.OSM, BASE_MAP.TAIWAN].map(type => ({
      type,
      name: BASE_MAP_NAME[type]
    }))
    const clickChangeBaseLayer = (mode: { type: BASE_MAP, name: string }) => {
      if (mapController.value) {
        mapController.value?.mapInstance.changeBaseMap(mode.type)

        mapModeBottomSheet.value = false
      }
    }

    return {
      mapModeBottomSheet,
      mapModes,
      clickChangeBaseLayer
    }
  }
})
